import { ActionsUnion, createAction } from '../helpers';
import { IReportUserPayload } from './types';

export enum EReportUserActionType {
  POST = 'REPORT_PHOTO/POST',
}

export const reportUserAction = {
  postReportUser: (payload: IReportUserPayload) =>
    createAction(EReportUserActionType.POST, payload),
};

export type TReportUserAction = ActionsUnion<typeof reportUserAction>;
